import { supabase } from "./client";
import { isSupabaseConfigured } from "./config";

const readFunctionError = async (error, fallbackMessage) => {
  let message = error?.message || fallbackMessage;

  if (error?.context) {
    try {
      const payload = await error.context.json();
      message = payload?.error || message;
    } catch {
      // Supabase can return a non-JSON gateway response while the function starts.
    }
  }

  return message;
};

const ensureGoogleMapsReady = () => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase no esta configurado para buscar ubicaciones.");
  }
};

const invokeBranchLocationGeocoder = async (body) => {
  ensureGoogleMapsReady();

  const { data, error } = await supabase.functions.invoke(
    "branch-location-geocode",
    { body }
  );

  if (error) {
    throw new Error(
      await readFunctionError(
        error,
        "No pudimos consultar Google Maps en este momento."
      )
    );
  }

  if (!data?.ok || !data?.location) {
    throw new Error(
      data?.error || "Google Maps no devolvio una ubicacion valida."
    );
  }

  return data.location;
};

export const searchBranchLocationOnGoogleMaps = async ({ branchId, query }) =>
  invokeBranchLocationGeocoder({
    branchId,
    action: "search",
    query: String(query || "").trim(),
  });

export const reverseBranchLocationOnGoogleMaps = async ({
  branchId,
  latitude,
  longitude,
}) =>
  invokeBranchLocationGeocoder({
    branchId,
    action: "reverse",
    latitude,
    longitude,
  });

